// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import type { TagListType } from 'types/Article';

export type Props = {
  tags: TagListType[]
};

class ArticleTags extends PureComponent<Props> {
  static defaultProps: { tags: Array<empty>, ... } = {
    tags: []
  };

  renderTags: (() => Array<any>) = () => {
    const { tags } = this.props;

    return tags.map<any>((t, index) => {
			const tagLink = t.source === 'categorie' ? `/actualites/${t.slug}` : `/tags/${t.slug}` ;

			return (
				<li key={index}>
					<Link to={tagLink}>
						<span className="tag">
							{t.name}
						</span>
					</Link>
				</li>
			);
		});
  };

  render() {
    return (
      <React.Fragment>
        <h3 className="mt-md-3 mt-lg-5 mb-3 ft-400">Dans cet article</h3>
        <ul className="list-tag mb-3">{this.renderTags()}</ul>
      </React.Fragment>
    );
  }
}

export default ArticleTags;
